import React from "react";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { ArrowForwardOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import { config } from "../../../config";
import {
  ACCENT,
  businessOnboardLandingContent,
  landingCta,
} from "./BusinessOnboard.constant";

/**
 * v2 onboarding landing. Uses the EXISTING landing content and icons
 * (title, subtitle, cards with icons) — only the visual layout is refreshed.
 */
export const BusinessOnboardLanding = () => {
  const navigate = useNavigate();
  const content =
    businessOnboardLandingContent[config.app.variant as "TALKVIT"] ||
    businessOnboardLandingContent.BANQUET_FIRST;

  const handleStart = () => navigate("/auth/signup/setup-company");

  return (
    <>
      <Navbar
        pageType="SIGNUP"
        accentColor={ACCENT.main}
        accentHoverColor={ACCENT.dark}
      />
      <Stack
        sx={{
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
          px: { xs: 2, md: 3 },
          pt: { xs: 9, md: 9 },
          pb: 2,
          boxSizing: "border-box",
          overflow: "hidden",
          backgroundColor: "grey.50",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "1.9rem", md: "2.5rem" },
            fontWeight: 700,
            textAlign: "center",
            lineHeight: 1.1,
            color: "text.primary",
          }}
        >
          {content.title}
        </Typography>
        <Typography
          sx={{
            color: "text.secondary",
            fontSize: { xs: "0.95rem", md: "1.1rem" },
            textAlign: "center",
            mt: 1,
            mb: { xs: 2.5, md: 3 },
            maxWidth: 700,
          }}
        >
          {content.subTitle}
        </Typography>

        <Box sx={{ width: "100%", maxWidth: 980 }}>
          <Grid container spacing={2.5} justifyContent="center">
            {content.cards.map((card, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Stack
                  sx={{
                    height: "100%",
                    p: { xs: 2.5, md: 3 },
                    borderRadius: "16px",
                    backgroundColor: "#fff",
                    border: "1px solid",
                    borderColor: "grey.200",
                    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                      borderColor: "grey.300",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mb: 1,
                      "& svg": {
                        fontSize: "2.75rem",
                        color: ACCENT.main,
                      },
                    }}
                  >
                    <card.icon />
                  </Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: "1.35rem",
                      fontWeight: 700,
                      textAlign: "center",
                      mb: 0.75,
                      color: "text.primary",
                    }}
                  >
                    {card.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.95rem",
                      color: "text.secondary",
                      textAlign: "center",
                    }}
                  >
                    {card.subTitle}
                  </Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Button
          onClick={handleStart}
          endIcon={<ArrowForwardOutlined />}
          sx={{
            mt: { xs: 2.5, md: 3 },
            px: 6,
            py: 1.4,
            borderRadius: "12px",
            fontSize: "1rem",
            fontWeight: 700,
            textTransform: "none",
            color: "#fff",
            backgroundColor: ACCENT.main,
            boxShadow: "none",
            "&:hover": { backgroundColor: ACCENT.dark, boxShadow: "none" },
          }}
        >
          {landingCta}
        </Button>
      </Stack>
    </>
  );
};

export default BusinessOnboardLanding;
